import { getInstalledRelatedApps } from './getInstalledRelatedApps';
import { type RelatedAppType } from '../schema/InstalledRelatedApp';

/**
 * @returns true if PWA is installed, false otherwise
 * Will return true only if the domain and the manifest url of the current page match the installed PWA.
 * Ex1: outlook.live.com is not a match with outlook.office.com or outlook-sdf.live.com
 * Ex2: /mail/minimanifests/pwa.json?culture=en-us is not a match with /mail/minimanifests/pwa.json?culture=hi-in
 */
export const isPWAInstalled = async (): Promise<boolean> => {
    const relatedApps = await getInstalledRelatedApps();
    return relatedApps.has('MiniPWA');
};
